'use strict';

/* globals socket, TMPlus */

(function () {
	const messages = [
		{
			method: 'get',
			message: 'plugins.tmplus.get',
		},
		{
			method: 'canCreate',
			message: 'plugins.tmplus.canCreate',
		},
		{
			method: 'addMember',
			message: 'plugins.tmplus.addMember',
		},
	];

	function init() {
		messages.forEach(({ method, message }) => {
			TMPlus.sockets[method] = async data => socket.emit(message, data);
		});
	}

	TMPlus.sockets = {};

	init();
}());
